import { observer } from 'mobx-react';
import SpcViewModel from './SpcViewModel';
import { Appl } from '../../../../core/Appl';
import { Button, Input, InputCalendar, InputDropdown, InputType } from '../../../../core/components/Index';
import { Tag } from 'primereact/tag';
import { formatFiscalYearLabel, formatFiscalYearDatesWithLeadingZeros } from '../../../../core/services/Helper';
import Helper from '../../../../core/services/Helper';

const MedicalLeaveForm = observer(() => {

  const vm = Appl.Services.get<SpcViewModel>('SpcViewModel');

  console.log("In Medical Leave Form");
   
  return (
    <>
    {!(vm.isAddingEstimate || vm.isEditingEstimate) && 
          <>
          <h1 className="w-full max-w-[830px] text-32px tracking-[-1%] text-[#363636] font-semibold mb-[16px]">Details Needed for Estimate — {vm.spcLovModel.serviceTypeListItems?.find(o=>o.id===vm.model?.spcTypeId)?.name}</h1>
          <p className="tracking--1percent">
          </p>
          <div className="text-[15px] font-normal leading-[175%] tracking-[-1.5%] mb-[20px]">
            <p className ="pt-3 pb-3">Enter the below information to generate a preliminary estimate for purchasing service credit related to your medical leave.</p>
            <ul className="marker:text-[10px] list-disc pl-5 pt-1">
                  <li>You may enter up to five separate leave periods.</li>
                  <li>Leave dates cannot overlap, and you must have returned to SCERS-covered employment after each leave.</li>
                  <li>
                    For each leave period, the system will calculate hours automatically; adjust if your leave balances were integrated with State Disability Insurance (SDI), partial pay, or other circumstances.
                  </li>
            </ul>
          </div>
          </>
      }
      {(vm.isAddingEstimate) && 
          <>
          <h1 className="w-full max-w-[830px] text-32px tracking-[-1%] text-[#363636] font-semibold mb-[16px]">Leave Period {vm.selectedEstimationIndex+1} Details — {vm.spcLovModel.serviceTypeListItems?.find(o=>o.id===vm.model?.spcTypeId)?.name}</h1>
          <p className="tracking--1percent">
          </p>
          <div className="text-[15px] font-normal leading-[175%] tracking-[-1.5%] mb-[20px]">
          <p className ="pt-3 pb-3">Add the details for your next leave period. Remember: periods can’t overlap, and you must have returned to SCERS-covered employment after each leave.</p>
          </div>
          </>
      }

       {(vm.isEditingEstimate) && 
          <>
          <h1 className="w-full max-w-[830px] text-32px tracking-[-1%] text-[#363636] font-semibold mb-[16px]">Leave Period {vm.selectedEstimationIndex+1} Details — {vm.spcLovModel.serviceTypeListItems?.find(o=>o.id===vm.model?.spcTypeId)?.name}</h1>
          <p className="tracking--1percent">
          </p>
          <div className="text-[15px] font-normal leading-[175%] tracking-[-1.5%] mb-[20px]">
          <p className ="pt-3 pb-3">Edit the details for this leave period. Remember: periods can’t overlap, and you must have returned to SCERS-covered employment after each leave.</p>
          </div>
          </>
      }
      <div className="max-w-6xl mx-auto">
          <h2 className="text-[22px] font-semibold text-[#363636] leading-[100%] tracking-[0px] mt-[32px] mb-[32px]"         >
            Your Information
          </h2>
          <div className="text-[15px] font-normal leading-[175%] tracking-[-1.5%] mb-[16px]">
            <p className="pt-3 font-bold">
              Employer
            </p>
            <p>
              Select your SCERS-covered employer for this leave period.
            </p>
          </div>
          <div className="mb-[24px]">
         <InputDropdown
            className="w-[343px] h-[38px]"
            id="mbrEmployer"
            value={vm.currentEstimationDetail.mbrEmployer}
            options={vm.spcLovModel?.employerListItems}
            optionValue="value"
            optionLabel="code"
            placeholder="Select Employer"
            onChange={async (e) => {
              vm.onInputChange(e, "mbrEmployer", vm.currentEstimationDetail);
              await vm.onEmployerChangeAsync();
            }}
            style={{ width: "375px" }}
            required={true}
          />
          </div>
          <div className="text-[15px] font-normal leading-[175%] tracking-[-1.5%] mb-[16px]">
            <p className="pt-3 font-bold">
              Membership Tier
            </p>
            <p>
              This is the SCERS tier that applied at the start of your medical leave.
            </p>
          </div>
          <div className="mb-[24px]">
            <InputDropdown
            id="mbrTierId"
            className='w-[285px] h-[38px]'
            value={vm.currentEstimationDetail.mbrTierId}
            options={vm.spcLovModel?.membershipTierListItems}
            optionValue="key"
            optionLabel="value"
            placeholder="Select Membership Tier"
            onChange={(e) => {
              vm.onInputChange(e, 'mbrTierId', vm.currentEstimationDetail);
            }}
            style={{ width: '325px' }}
            required={true}
          />
          </div>

          <div className="text-[15px] font-normal leading-[175%] tracking-[-1.5%] mb-[16px]">
            <p className="pt-3 font-bold">
              Date of Medical Leave
            </p>
            <p>
              Please enter the start and end dates of your unpaid medical leave.
            </p>
          </div>
          <div className="md:max-w-[400px] grid grid-cols-1 md:grid-cols-2 gap-[20px] mb-[24px]">
            <div className=" ">
              <InputCalendar
                  className='w-[50vw] md:w-[180px] h-[38px]'
                  id="startDate"
                  value={vm.currentEstimationDetail?.startDate!}
                  label="From"
                  showHint={true}
                  onChange={(e) => {
                    vm.onInputChange(e, 'startDate', vm.currentEstimationDetail);
                  }}
                  onBlur={async () => await vm.onEstimationDateChangeAsync(1)}
                  required={false}
                />
            </div>
            <div className=" ">
              <InputCalendar
                  className='w-[50vw] md:w-[180px] h-[38px]'
                  id="endDate"
                  value={vm.currentEstimationDetail?.endDate!}
                  label="To"
                  showHint={true}
                  onChange={(e) => {
                    vm.onInputChange(e, 'endDate', vm.currentEstimationDetail);
                  }}
                  onBlur={async () => await vm.onEstimationDateChangeAsync(2)}
                  required={false}
                />
            </div>
          </div>
          <div className="text-[15px] font-normal w-full max-w-[830px] leading-[175%] tracking-[-1.5%] mb-[16px]">
            <p className="pt-3 font-bold">
              Estimated Hours of Leave
            </p>
            <p>
              We calculate hours from your date range assuming a 40-hour work week. Adjust this value to account if your leave balances were integrated with State Disability Insurance (SDI), partial pay, or any unpaid time that should not be included.
            </p>
          </div>
          <div className='flex flex-wrap justify-stretch items-center gap-[20px] mb-[32px]'>
            <div>
              <Input
                    id="estSvcHours"
                    value={vm.currentEstimationDetail.estSvcHours}
                    inputType={InputType.Number}
                    label={vm.currentEstimationDetail?.splitSegment === true ? formatFiscalYearDatesWithLeadingZeros(formatFiscalYearLabel(vm.currentEstimationDetail?.fiscalYearLabel1)) : undefined}
                    onChange={(e:any) => {
                        vm.currentEstimationDetail.estSvcHours = e.originalEvent?.currentTarget?.value.replace(/,/g, '') ;
                      }}
                    minFractionDigits={0}
                    formatNumbers={true}
                    style={{ width: '180px' }}
                />
            </div>
            {vm.currentEstimationDetail?.startDate && vm.currentEstimationDetail?.endDate && vm.currentEstimationDetail?.estSvcHours !== undefined && vm.currentEstimationDetail?.splitSegment === false && (
              <div className="mt-[6px] max-h-[60px] flex justify-stretch cursor-pointer focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 rounded-md">
                <div className="border-2 border-orange-500 rounded-l-md px-1 flex items-center ">
                  <svg className="w-3 h-3">
                    <path
                      d="M5.4996 0.5C5.8047 0.5 6.08617 0.661144 6.24087 0.925421L10.8818 8.83224C11.0387 9.09866 11.0387 9.4274 10.8861 9.69382C10.7336 9.96025 10.4478 10.1257 10.1406 10.1257H0.858643C0.551395 10.1257 0.265632 9.96025 0.113082 9.69382C-0.0394677 9.4274 -0.0373191 9.09651 0.117379 8.83224L4.75834 0.925421C4.91304 0.661144 5.1945 0.5 5.4996 0.5ZM5.4996 3.2502C5.21384 3.2502 4.98394 3.4801 4.98394 3.76586V6.17228C4.98394 6.45804 5.21384 6.68794 5.4996 6.68794C5.78536 6.68794 6.01526 6.45804 6.01526 6.17228V3.76586C6.01526 3.4801 5.78536 3.2502 5.4996 3.2502ZM6.18715 8.06304C6.18715 7.88069 6.11471 7.70581 5.98577 7.57687C5.85683 7.44793 5.68195 7.37549 5.4996 7.37549C5.31725 7.37549 5.14237 7.44793 5.01343 7.57687C4.88449 7.70581 4.81205 7.88069 4.81205 8.06304C4.81205 8.24539 4.88449 8.42027 5.01343 8.54921C5.14237 8.67815 5.31725 8.75059 5.4996 8.75059C5.68195 8.75059 5.85683 8.67815 5.98577 8.54921C6.11471 8.42027 6.18715 8.24539 6.18715 8.06304Z"
                      fill="#CF7119"
                    />
                  </svg>
                </div>
                <div className='!font-extrabold'>
                  <Tag
                    severity="warning"
                    value="Hours calculated automatically — adjust as needed. Click to learn more."
                    className="!rounded-l-none !font-bold font-[700] !h-full mb-[2px]" style={{textTransform: 'none'}}
                    onClick={()=>Appl.MessageBox.show('The calculator automatically determines hours based on your leave dates and a 40-hour work week. This may not match your actual unpaid hours if you received partial pay, State Disability Insurance (SDI), or had intermittent absences. You can adjust the hours field to better reflect your actual situation.','About Estimated Hours of Leave','','Close',true)}
                  />
                </div>
              </div>
            )}

            {/*Text Box In a Slightly Different Spot if Split Period*/}
            {vm.currentEstimationDetail?.startDate && vm.currentEstimationDetail?.endDate && vm.currentEstimationDetail?.estSvcHours !== undefined && vm.currentEstimationDetail?.splitSegment === true &&(
              <div className="md:ml-[-100px] md:!mt-[30px] max-h-[60px] flex justify-stretch cursor-pointer focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 rounded-md">
                <div className="border-2 border-orange-500 rounded-l-md px-1 flex items-center ">
                  <svg className="w-3 h-3">
                    <path
                      d="M5.4996 0.5C5.8047 0.5 6.08617 0.661144 6.24087 0.925421L10.8818 8.83224C11.0387 9.09866 11.0387 9.4274 10.8861 9.69382C10.7336 9.96025 10.4478 10.1257 10.1406 10.1257H0.858643C0.551395 10.1257 0.265632 9.96025 0.113082 9.69382C-0.0394677 9.4274 -0.0373191 9.09651 0.117379 8.83224L4.75834 0.925421C4.91304 0.661144 5.1945 0.5 5.4996 0.5ZM5.4996 3.2502C5.21384 3.2502 4.98394 3.4801 4.98394 3.76586V6.17228C4.98394 6.45804 5.21384 6.68794 5.4996 6.68794C5.78536 6.68794 6.01526 6.45804 6.01526 6.17228V3.76586C6.01526 3.4801 5.78536 3.2502 5.4996 3.2502ZM6.18715 8.06304C6.18715 7.88069 6.11471 7.70581 5.98577 7.57687C5.85683 7.44793 5.68195 7.37549 5.4996 7.37549C5.31725 7.37549 5.14237 7.44793 5.01343 7.57687C4.88449 7.70581 4.81205 7.88069 4.81205 8.06304C4.81205 8.24539 4.88449 8.42027 5.01343 8.54921C5.14237 8.67815 5.31725 8.75059 5.4996 8.75059C5.68195 8.75059 5.85683 8.67815 5.98577 8.54921C6.11471 8.42027 6.18715 8.24539 6.18715 8.06304Z"
                      fill="#CF7119"
                    />
                  </svg>
                </div>
                <div className='!font-extrabold'>
                  <Tag
                    severity="warning"
                    value="Hours calculated automatically — adjust as needed. Click to learn more."
                    className="!rounded-l-none !font-bold font-[700] !h-full mb-[2px]" style={{textTransform: 'none'}}
                    onClick={()=>Appl.MessageBox.show('The calculator automatically determines hours based on your leave dates and a 40-hour work week. This may not match your actual unpaid hours if you received partial pay, State Disability Insurance (SDI), or had intermittent absences. You can adjust the hours field to better reflect your actual situation.','About Estimated Hours of Leave','','Close',true)}
                  />
                </div>
              </div>
            )}
          </div>
          {/*Error Message if Value Is Less Than or Equal to Zero*/}
          {vm.currentEstimationDetail &&
            vm.currentEstimationDetail.estSvcHours !== undefined &&
            vm.currentEstimationDetail.estSvcHours <= 0 && (
                <div className="text-red-600 text-[15px] font-semibold leading-[125%] mt-[-32px] mb-[-5px] w-[200px]">
                  Estimated hours must be at<br /> <center> least 1</center>
                </div>
            )}
            
          {/*Code to Handle Split Periods*/}
          {vm.currentEstimationDetail?.splitSegment === true &&
          (
            <>
              <div className='flex flex-wrap justify-stretch items-center gap-[20px] mb-[24px]'>
                  <div>
                    <Input
                        id="estSvcSplitHours"
                        value={vm.currentEstimationDetail.estSvcSplitHours!}
                        inputType={InputType.Number}
                        label={formatFiscalYearDatesWithLeadingZeros(formatFiscalYearLabel(vm.currentEstimationDetail?.fiscalYearLabel2))}
                        onChange={(e:any) => {
                          vm.currentEstimationDetail.estSvcSplitHours = e.originalEvent?.currentTarget?.value.replace(/,/g, '') ;
                        }}
                        minFractionDigits={0}
                        formatNumbers={true}
                        required={false}
                        style={{ width: '180px' }}
                      />
                  </div>
                  {vm.currentEstimationDetail?.startDate && vm.currentEstimationDetail?.endDate && vm.currentEstimationDetail?.estSvcSplitHours != undefined && (
                    <div className="md:ml-[-100px] md:!mt-[30px] max-h-[60px] flex justify-stretch cursor-pointer focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 rounded-md">
                      <div className="border-2 border-orange-500 rounded-l-md px-1 flex items-center ">
                        <svg className="w-3 h-3">
                          <path 
                            d="M5.4996 0.5C5.8047 0.5 6.08617 0.661144 6.24087 0.925421L10.8818 8.83224C11.0387 9.09866 11.0387 9.4274 10.8861 9.69382C10.7336 9.96025 10.4478 10.1257 10.1406 10.1257H0.858643C0.551395 10.1257 0.265632 9.96025 0.113082 9.69382C-0.0394677 9.4274 -0.0373191 9.09651 0.117379 8.83224L4.75834 0.925421C4.91304 0.661144 5.1945 0.5 5.4996 0.5ZM5.4996 3.2502C5.21384 3.2502 4.98394 3.4801 4.98394 3.76586V6.17228C4.98394 6.45804 5.21384 6.68794 5.4996 6.68794C5.78536 6.68794 6.01526 6.45804 6.01526 6.17228V3.76586C6.01526 3.4801 5.78536 3.2502 5.4996 3.2502ZM6.18715 8.06304C6.18715 7.88069 6.11471 7.70581 5.98577 7.57687C5.85683 7.44793 5.68195 7.37549 5.4996 7.37549C5.31725 7.37549 5.14237 7.44793 5.01343 7.57687C4.88449 7.70581 4.81205 7.88069 4.81205 8.06304C4.81205 8.24539 4.88449 8.42027 5.01343 8.54921C5.14237 8.67815 5.31725 8.75059 5.4996 8.75059C5.68195 8.75059 5.85683 8.67815 5.98577 8.54921C6.11471 8.42027 6.18715 8.24539 6.18715 8.06304Z"
                            fill="#CF7119"
                          />
                        </svg>
                      </div>
                      <div className='!font-extrabold'>
                        <Tag
                          severity="warning"
                          value="Hours calculated automatically — adjust as needed. Click to learn more."
                          className="!rounded-l-none !font-bold font-[700] !h-full mb-[2px]" style={{textTransform: 'none'}}
                          onClick={()=>Appl.MessageBox.show('The calculator automatically determines hours based on your leave dates and a 40-hour work week. This may not match your actual unpaid hours if you received partial pay, State Disability Insurance (SDI), or had intermittent absences. You can adjust the hours field to better reflect your actual situation.','About Estimated Hours of Leave','','Close',true)}
                        />
                      </div>
                    </div>
                  )}
              </div>

              {vm.currentEstimationDetail &&
                  vm.currentEstimationDetail.estSvcSplitHours !== undefined && vm.currentEstimationDetail.estSvcSplitHours != null &&
                  vm.currentEstimationDetail.estSvcSplitHours <= 0 && (
                      <div className="text-red-600 text-[15px] font-semibold leading-[125%] mt-[-20px] mb-[-5px] w-[200px]">
                        Estimated hours must be at<br /> <center> least 1</center>
                      </div>
                )}
            </>
          )}

          {/*Error Message if Value Is Less Than or Equal to Zero*/}
           <div className="text-[15px] font-normal leading-[175%] tracking-[-1.5%] mb-[16px]">
              <p className="pt-3 font-bold">
                Estimated Compensation
              </p>
              <p className='text-[15px] leading-[175%] tracking-[-1.5%]'>
                Enter your pay rate at the time of your leave and select the corresponding pay frequency. 
              </p>
              <p className='text-[15px] leading-[175%] tracking-[-1.5%]'>
                If your pay rate changed during this period, we recommend using the higher pay rate to produce a more conservative estimate.
              </p>
          </div>
          <div className="flex flex-wrap items-center gap-[20px] mb-[32px]">
            <div>
              <Input
                  id="estmComp"
                  value={vm.currentEstimationDetail.estmComp}
                  inputType={InputType.Number}
                  onChange={(e:any) => {
                    vm.currentEstimationDetail.estmComp = e.originalEvent?.currentTarget?.value.replace(/,/g, '') ;
                  }}
                  prefix="$"
                  prefixPosition="left"
                  minFractionDigits={2}
                  formatNumbers={true}
                  numberAlignment="right"
                  placeholder="e.g. 12,000.00"
                  className="!w-[50vw] md:!w-[177px]"
                />
            </div>
              <div>
                <InputDropdown
                  id="comFreqId"
                  value={vm.currentEstimationDetail.comFreqId}
                  options={vm.spcLovModel?.compensationFrequencyListItems}
                  optionValue="key"
                  optionLabel="value"
                  placeholder="Select Frequency"
                  onChange={(e) => {
                    vm.onInputChange(e, 'comFreqId', vm.currentEstimationDetail);
                  }}
                  required={true}
                  className='!w-[50vw] md:!w-[285px] !h-[38px] mt-[4px]'
                />
              </div>
          </div>
          </div>
          <div className="flex mt-6 flex-wrap gap-2 sm:flex-nowrap">
          <Button
            title="Save & Continue"
            rounded
            className='border border-[#34571933] !w-[161px]'
            onClick={async () => {
              await vm.onEnterDetailsStepChangeAsync();
            }}
            disabled={
                      vm.currentEstimationDetail?.mbrEmployer === ""
                      || vm.currentEstimationDetail?.mbrTierId === undefined
                      || vm.currentEstimationDetail?.endDate === null
                      || vm.currentEstimationDetail?.startDate === null
                      || vm.currentEstimationDetail?.estSvcHours === undefined
                      || vm.currentEstimationDetail?.estmComp === undefined
                      || vm.currentEstimationDetail?.comFreqId === undefined
                      || vm.currentEstimationDetail.estSvcHours === undefined
                      || vm.currentEstimationDetail.estSvcHours <= 0
                    }
          />
          {(vm.isAddingEstimate || vm.isEditingEstimate) && <Button title="Cancel" severity='warning' outlined rounded onClick={async () => await vm.cancelAddEstimateAsync()} />}
        </div>
    </>
  );
});

export default MedicalLeaveForm;
